import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { BonusProgram } from './BonusProgram.types';

export function useBonusProgramData(): Page<BonusProgram>['templateFields'] {
  return useCurrentPage<Page<BonusProgram>>().templateFields;
}
